// extracted by mini-css-extract-plugin
export default {"clickable":"CodeBlock_clickable__W4x7U"};